<script lang="ts">
  import Filter from "../Filter.svelte";
  import { SearchState } from "../../services/search-service";
  import { deleteSearchQueryStringParameter, setQueryStringParameter } from "../../url";
  import TooltipHybridButton from "./TooltipHybridButton.svelte";
  import type {KeywordsAggregation} from "../../models/common.interface";

  // getting keywords from the hugo static files NOT USING KEYWORDS.JSON ANYMORE
  export let keywords: KeywordsAggregation[] = [];

  let keywordSearchParams = [];
  SearchState.subscribe((search) => {
    keywordSearchParams = search.params.getAll("keywords")
  })

  // handles the text input filter
  $: keywordFilteredTerms = keywords ? [] : keywords.filter(item => item.name.includes(keywordSearchTerm.toUpperCase()));
  let keywordSearchTerm = "";

  // let statusMessage = "";

  function handleKeywordChange(id: string) {
    if (!keywordSearchParams.includes(id)) {
      setQueryStringParameter("keywords", id, true);
    } else {
      deleteSearchQueryStringParameter("keywords", id);
    }
  }

  // filters the keyword terms
  function keywordSearchTerms() {
    return keywords.filter(item => item.name.includes(keywordSearchTerm.toUpperCase()));
  }

</script>

<li class="mb-1">
  <form>
    <fieldset>
      <legend id="keywordLegend" class="mb-2 fs-5">
        Keyword
        <!-- tooltip icon -->
        <TooltipHybridButton
          searchUrlQueryParam="keyword"
          tooltip="This is a list of all keywords available in data access. <b> Keywords </b>
            represent what kind of data are observed by the dataset."
        />
      </legend>
      <!-- filter and list of keywords -->
      <div
        style="border-bottom: 2px solid #B0BBBB;"
        class="px-1"
        id="keyword-search-input"
        role="region"
        aria-labelledby="keywordLegend"
      >
        <!-- text input filter for list of keywords -->
        <!-- remove it if there are no keywords -->
        {#if keywords.length > 0}
        <div class="mb-2">
          <label for="filter-keyword" class="form-label visually-hidden">Filter keywords by name</label>
          <Filter
            bind:searchTerm={keywordSearchTerm}
            id="filter-keyword"
            on:input={keywordSearchTerms}
            title="Keyword Filter Box"
            ariaLabel="Filter keywords by name"
          />
        </div>
        {/if}

        <!-- if no results in filtered list -->
        {#if (keywordSearchTerm && keywordFilteredTerms.length === 0) || keywords.length === 0}
          No Keyword Results
        {:else if keywordFilteredTerms.length > 0}
          <!-- if results match, show that filtered list -->
          <div style="height: 255px; max-height: 255px; overflow-y: scroll" class="px-1">
            <!-- keyword checkbox list w/ label -->
            {#each keywordFilteredTerms as k}
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="keyword-{k.name}-filter-checkbox"
                  aria-checked={keywordSearchParams.includes(k.name)}
                  value={k.name}
                  checked={keywordSearchParams.includes(k.name)}
                  on:change={() => handleKeywordChange(k.name)}
                />
                <label class="form-check-label" for="keyword-{k.name}-filter-checkbox">
                  {k.name.toLowerCase()}({k.associatedDatasets})
                </label>
              </div>
            {/each}
          </div>
        {:else}
          <!-- else show everything -->
          <div style="height: 255px; max-height: 255px; overflow-y: scroll" class="px-1">
            <!-- keyword checkbox list w/ label -->
            {#each keywords || [] as k}
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value={k.name}
                  id="keyword-{k.name}-checkbox"
                  checked={keywordSearchParams.includes(k.name)}
                  on:change={() => handleKeywordChange(k.name)}
                />
                <label class="form-check-label" for="keyword-{k.name}-checkbox">
                  {k.name.toLowerCase()} ({k.associatedDatasets})
                </label>
              </div>
            {/each}
          </div>
        {/if}
      </div>
    </fieldset>
  </form>
</li>

{#if $SearchState.params.has("keywords")}
  {#each keywordSearchParams || [] as k}
    <div class="d-flex py-1">
      <span
        style="overflow-x: hidden; text-overflow: ellipsis"
        class="badge rounded-pill text-bg-dark pb-0 pe-3 pt-1"
        role="status"
        aria-label="keyword search pill: {keywords?.find((x) => x.name === k)?.name.toLowerCase()}"
      >
        <button
          type="button"
          class="btn p-0 m-0"
          on:click={() => deleteSearchQueryStringParameter("keywords", k)}
        >
          <i
            class="bi bi-x text-bg-dark"
            aria-label="Delete keyword {keywords?.find((x) => x.name === k)?.name.toLowerCase()}"
          ></i>
        </button>
        {keywords?.find((x) => x.name === k)?.name.toLowerCase()}
      </span>
    </div>
  {/each}
{/if}
